import axios from "axios";
import { localStorageItem } from './../../../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../../../auth/core/_consts";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_KE_HOACH = API + "/tech-transfer-info";


export const addPhieuKeHoach = (data: any) => {
  let url = API_KE_HOACH;
  return axios.post(url, data);
};
export const updatePhieuKeHoach = (id: string, data: any) => {
  let url = API_KE_HOACH + `/${id}`;
  return axios.put(url, data);
};

export const searchPhieuKeHoach = (searchData: any) => {
  const url = `${API_KE_HOACH}` + `/search`;
  return axios.post(url, searchData);
};

export const searchPhieuKyThuat = (searchData: any) => {
  const url = `${API}` + `/tech-transfer-info/search`;
  return axios.post(url, searchData);
};

export const searchdsDot = (techTransferInfoId: string | undefined) => {
  var url = API + `/tech-transfer-batch/by-info/${techTransferInfoId}`
  return axios.get(url)
}

export const deletePhieuKeHoach = (trackerCode: string, id: string) => {
  const url = `${API_KE_HOACH}` + `/${trackerCode}/${id}`;
  return axios.delete(url);
};

export const searchOptionNhanVien = (searchData: any) => {
  const url = `${API}` + `/obs-complex-categories/danhmucnhanvien/search`;
  return axios.post(url, searchData);
};

export const searchOptionVaiTro = (searchData: any) => {
  const url = `${API}` + `/obs-complex-categories/dohadmvaitro/search`;
  return axios.post(url, searchData);
};

export const saveDot = (id: string, payload: any) => {
  const url = `${API}` + `/tech-transfer-batch/${id}`;
  return axios.put(url, payload);
};

export const updateStatusDot = (id: string, payload?: any) => {
  const url = `${API}` + `/tech-transfer-batch/update-status/${id}?status=${Number(payload?.status)}&description=${payload?.description}`;
  return axios.put(url);
};
export const updateStatusNghiemThu = (id: string, payload?: any) => {
  const url = `${API}` + `/tech-transfer-info/update-status/${id}?status=${Number(payload?.status)}`;
  return axios.put(url);
};

export const saveNghiemThu = (id: string, payload?: any) => {
  const url = `${API}` + `/tech-transfer-info/${id}`;
  return axios.put(url, payload);
};

export const getListTrangTB = (payload: any) => {
  const url = `${API}/obs-complex-categories/danhmuctrangthietbi/search`;
  return axios.post(url, payload);
};
export const getListCoSoVatChat = (payload: any) => {
  const url = `${API}/obs-complex-categories/danhmuccosovatchat/search`;
  return axios.post(url, payload);
};

export const getListHD = (payload: any) => {
  const url = `${API}/obs-complex-categories/danhmuchopdong/search`;
  return axios.post(url, payload);
};

export const getTechTransferPersonnel = (id: string) => {
  const url = `${API}/tech-transfer-personnel/by-tech-transfer-info/${id}`;
  return axios(url);
};
